import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, industriesActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, industriesActions);

export default slice.reducer;
